import { render } from "./RelatedProcessing.vue?vue&type=template&id=6c5a3112&scoped=true&ts=true&lang=pug"
import script from "./RelatedProcessing.vue?vue&type=script&lang=ts&setup=true"
export * from "./RelatedProcessing.vue?vue&type=script&lang=ts&setup=true"

import "./RelatedProcessing.vue?vue&type=style&index=0&id=6c5a3112&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5a3112"]])

export default __exports__